

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-[#C8A2C8] mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Renew Integrative Wellness
            </h3>
            <p className="text-[#B0B0B0] mb-4">
              Transform your health from the inside out with cutting-edge integrative wellness treatments.
            </p>
            <div className="space-y-2">
              <p className="flex items-center text-[#B0B0B0]">
                <i className="ri-map-pin-line mr-2 text-[#C8A2C8]"></i>
                1160 Varnum Street N.E, Washington, D.C 20017 Suite #218
              </p>
              <p className="flex items-center text-white">
                <i className="ri-phone-line mr-2 text-[#C8A2C8]"></i>
                <a href="tel:202-883-6057" className="hover:text-[#C8A2C8]">(202) 883-6057</a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><button onClick={() => scrollToSection('services')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Peptide Therapy</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Weight Loss</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">IV Therapy</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Mental Health</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Hair Growth</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Longevity</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li><button onClick={() => scrollToSection('about')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">About Us</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Contact</button></li>
              <li><button onClick={() => window.REACT_APP_NAVIGATE('/consultation')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Book Appointment</button></li>
              <li><button onClick={() => window.REACT_APP_NAVIGATE('/privacy-policy')} className="text-[#B0B0B0] hover:text-[#C8A2C8] cursor-pointer">Privacy Policy</button></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#D0D0D0] mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#B0B0B0] text-sm">
            © 2025 Renew Integrative Wellness. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

